document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
    if (!menu.contains(event.target) || event.target.closest('a')) {
      menu.removeAttribute('open');
    }
  });
});

// Portfolio filtering and full-image viewer.
document.addEventListener('DOMContentLoaded', function () {
  var filters = document.querySelectorAll('[data-portfolio-filter]');
  var cards = document.querySelectorAll('[data-portfolio-category]');

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      var filter = button.getAttribute('data-portfolio-filter');
      filters.forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      cards.forEach(function (card) {
        var categories = (card.getAttribute('data-portfolio-category') || '').split(' ');
        card.hidden = filter !== 'all' && categories.indexOf(filter) === -1;
      });
    });
  });

  var dialog = document.querySelector('[data-portfolio-dialog]');
  if (!dialog) return;
  var dialogImage = dialog.querySelector('[data-portfolio-dialog-image]');
  var dialogTitle = dialog.querySelector('[data-portfolio-dialog-title]');
  var closeButton = dialog.querySelector('[data-portfolio-close]');

  document.querySelectorAll('[data-portfolio-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      dialogImage.src = button.getAttribute('data-src');
      dialogImage.alt = button.getAttribute('data-title') || 'Flexx Security project photo';
      dialogTitle.textContent = button.getAttribute('data-title') || '';
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });
  });

  if (closeButton) closeButton.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
});
